import { JobDetailType } from './job-detail';
import { CULTURE_PREFERENCE } from '@/constants/culture-preference';
import { OptionType } from '@/types/common';
import { SimplifyCityType } from '@/types/city';
import { CulturePreferenceType } from '@/types/culture-preference';

export enum RestTypeEnum {
  None = '',
  Double = 'double',
  Single = 'single',
  BigSmall = 'big_small',
  Shift = 'shift',
}

export type CompanyBasicInfoType = {
  industry: OptionType | null;
  location: { location: OptionType; address: string };
  size: string;
  financing_stage: string | null;
} & OptionType;

export type BusinessLicenseType = {
  name: string;
  registered_address: string;
  unified_social_credit_code: string;
  legal_representative: string;
  registered_capital: string;
  date_of_establishment: string;
  business_type: string;
  operating_status: string;
  business_scope: null;
  license_picture: string;
};

export type BenefitType = {
  type: string;
} & OptionType;

export type WorkScheduleType = {
  rest_type: string;
  work_over: string;
  start_time: string;
  end_time: string;
  is_check_in: boolean;
  is_flexible_work: boolean;
};

export type TeamType = {
  name: string;
  type: 'default' | 'custom';
  display: boolean;
  culture_preference: Record<string, number>;
};

export type SimpleCompanyType = {
  logo: null | string;
  description: null | string;
} & OptionType;

export type CompanyValueType = {
  type: null | string;
  logo: null | string;
  description: null | string;
  status: number;
  business_license: BusinessLicenseType | null;
  medias: { images: string[]; videos: string[] };
  team_executives: {
    photo: string;
    name: string;
    description: string;
    age_level: string;
    position: string;
  }[];
  products: {
    photo: string;
    name: string;
    description: string;
    link: string;
  }[];
  benefits: BenefitType[];
  work_schedule: WorkScheduleType;
  settings: {
    teams: TeamType[];
  };
  job_opportunity?: JobDetailType[];
  related_jobs?: JobDetailType[];
  cities?: SimplifyCityType[];
  similar_companies?: SimpleCompanyType[];
  seo_content: Record<string, any>;
  [CULTURE_PREFERENCE]: CulturePreferenceType;
} & CompanyBasicInfoType;
